import { render, staticRenderFns } from "./chosenClass.vue?vue&type=template&id=9ff60f20&scoped=true&"
import script from "./chosenClass.js?vue&type=script&lang=js&"
export * from "./chosenClass.js?vue&type=script&lang=js&"
import style0 from "./chosenClass.vue?vue&type=style&index=0&id=9ff60f20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff60f20",
  null
  
)

export default component.exports